import * as vp from 'vopay';
import { useEffect, FC, useState } from 'react';
import RefundTransactionInfo from './RefundTransactionInfo';
import useFetchEFTFundTransaction from '@/hooks/useApi/useFetchEFTFundTransaction';
import useFetchEFTWithdrawTransaction from '@/hooks/useApi/useFetchEFTWithdrawTransaction';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import LinkedTransactionInfo from './LinkedTransactionInfo';

type TransactionType = vp.EftTransactionResponse & {
  ParentTransaction?: vp.LinkedTransactionsMap;
  SubTransactions?: vp.LinkedTransactionsMap;
};

type RefundTransactionContainerProps = {
  TransactionID: string;
  isParent?: boolean;
  jwt: string;
};

const RefundTransactionContainer: FC<RefundTransactionContainerProps> = ({ TransactionID, isParent = false, jwt }) => {
  const { userSettings } = useUserSettingsProvider();
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [parentTransactions, setParentTransactions] = useState<vp.LinkedTransactionsMap>();
  const [subTransactions, setSubTransactions] = useState<vp.LinkedTransactionsMap>();
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<TransactionType>();

  const [eftFundTransaction, getEftFundTransaction] = useFetchEFTFundTransaction({ bearer: jwt });
  const [eftWithdrawTransaction, getEftWithdrawTransaction] = useFetchEFTWithdrawTransaction({ bearer: jwt });

  useEffect(() => {
    if (TransactionID !== undefined) {
      getEftFundTransaction({ TransactionID, Timezone: userSettings.timezone });
      getEftWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone });
    }
    setIsDataFeched(true);
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (isDataFeched && Object.values(eftWithdrawTransaction).length > 0 && eftWithdrawTransaction.ParentTransaction) {
      const subTransactionsList: vp.LinkedTransactionsMap = Object.values(eftWithdrawTransaction.ParentTransaction);
      setParentTransactions(subTransactionsList);
    }
  }, [eftWithdrawTransaction]);

  useEffect(() => {
    if (isDataFeched && Object.values(eftFundTransaction).length > 0 && eftFundTransaction.SubTransactions) {
      const subTransactionsList: vp.LinkedTransactionsMap = Object.values(eftFundTransaction.SubTransactions);

      setSubTransactions(subTransactionsList);
    }
  }, [eftFundTransaction]);

  useEffect(() => {
    if (eftFundTransaction.Success) {
      setTransaction(eftFundTransaction);
    }
  }, [eftFundTransaction]);

  useEffect(() => {
    if (eftWithdrawTransaction.Success) {
      setTransaction(eftWithdrawTransaction);
    }
  }, [eftWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && <RefundTransactionInfo transaction={transaction} isParent={isParent} jwt={jwt} />}
      {parentTransactions && (
        <LinkedTransactionInfo
          LinkedTransactions={parentTransactions}
          Currency={eftWithdrawTransaction?.Currency || 'CAD'}
        />
      )}
      {subTransactions && (
        <LinkedTransactionInfo
          LinkedTransactions={subTransactions}
          Currency={eftWithdrawTransaction?.Currency || 'CAD'}
        />
      )}
    </div>
  );
};

export default RefundTransactionContainer;
